import React from 'react';
import { st, classes } from './DesignedDivider.st.css';
import type { DividerName } from 'root/utils/divider';
import { getAllDividerStylesNames } from 'root/utils/divider';

export const DesignedDivider = ({
  className,
  dividerName,
}: {
  className: HTMLHRElement['className'];
  dividerName: DividerName;
}) => {
  const stylesVarMap = getAllDividerStylesNames({
    styleParamName: dividerName,
  });

  return <hr className={st(className, classes.divider)} style={stylesVarMap} />;
};
